import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Logo from "../images/shine_header_logo.png";

const BACKEND_BASE = process.env.REACT_APP_API_URL || "";
const PDF_PATH = "/portfolio_pdf/CompanyPortfolio-ShineInfosoft.pdf";
const PDF_URL = BACKEND_BASE ? `${BACKEND_BASE}${PDF_PATH}` : PDF_PATH;

const Header = () => {
  const location = useLocation();

  const { pathname } = location;

  const splitLocation = pathname.split("/");

  const [isActive, setIsActive] = useState(false);

  const openMenu = () => {
    setIsActive(!isActive);
  };

  const closeMenu = () => {
    setIsActive(!isActive);
  };

  return (
    <>
      <nav className="headerSection">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-3 col-sm-4 col-12">
              <Link to="/">
                <img src={Logo} alt="Hire Developer" />
              </Link>
            </div>
            {/* <div className='barIcon'>
                            <i className={isActive ? "fa fa-bars d-none" : "fa fa-bars d-block"} onClick={openMenu}></i>
                            <i className={isActive ? "fa fa-times d-block" : "fa fa-times d-none"}  onClick={closeMenu}></i>
                        </div> */}
            <div className={isActive ? "HireButton active" : "HireButton"}>
              <a
                href={PDF_URL}
                className="btn active mr-0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Company Profile</span>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
